import {
  FETCH_ASSESSMENT_VERSIONS,
  UPDATE_ASSESSMENT_VERSIONS,
  UPDATE_ASSESSMENT_VERSIONS_COMPLETE
} from '../actions/types';

//user state can be false (if not logged in), authenticating (if currently fetching user), or the user{} object

const DEFAULT_STATE = {
  loading: true,
  saving: false,
  error: null,
  data: null,
}

export default function(state = DEFAULT_STATE, action){
  switch(action.type){
    case FETCH_ASSESSMENT_VERSIONS:
      return {
        ...state,
        saving: false,
        loading: false,
        data: action.payload
      }
    case UPDATE_ASSESSMENT_VERSIONS:
      return {
        ...state,
        saving: true
      }
    case UPDATE_ASSESSMENT_VERSIONS_COMPLETE:
    return {
      ...state,
      data: action.payload,
      saving: false
    }
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/assessmentVersionsReducer.js